import {
  REQUEST_CAMPAIGN_LIST,
  REQUEST_CAMPAIGN
} from './mutation-types'

export default {
  [REQUEST_CAMPAIGN_LIST](state, receivedData) {
    state.campaignList = receivedData.content;
    state.campaignListCount = receivedData.totalElements;
  },
  [REQUEST_CAMPAIGN](state, receivedData) {
    state.campaign = receivedData
  },
}